import { Customer } from "../models/Customer";
import { host, getRequest, patchRequest, postRequest, deleteRequest } from "./apiService";

export async function getCustomers() {
	return getRequest<Customer[]>(`${host}/api/customer`);
}

export async function updateCustomer(id: string, customer: Customer) {
	return patchRequest<void>(
		`${host}/api/customer/${id}`, customer
	);
}

export async function addCustomer(newCustomer: Customer) {
	const { id, ...objectWithoutId } = newCustomer;
	return postRequest<Customer | undefined>(
		`${host}/api/customer`, objectWithoutId
	);
}

export async function deleteCustomer(id: string) {
	return deleteRequest(`${host}/api/customer/${id}`)
}